/**
 * Persist the selected dashboard pack per model in `global-modal-filters`
 * (same store as dashboard page + scenario preferences).
 */

const STORAGE_KEY = 'global-modal-filters';

export function readSelectedDashboardId(modelId: number | string): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as Record<string, { selectedDashboardId?: string }>;
    const entry = data[Number(modelId)];
    const id = entry?.selectedDashboardId;
    return id ? String(id) : null;
  } catch {
    return null;
  }
}

export function saveSelectedDashboardId(
  modelId: number | string,
  dashboardId: string | number | undefined | null,
): void {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const data = raw ? JSON.parse(raw) : {};
    const key = Number(modelId);
    data[key] = {
      ...data[key],
      selectedDashboardId: dashboardId != null ? String(dashboardId) : undefined,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // private mode / quota — ignore
  }
}
